import Colors from 'assets/Colors';
import Instagram from 'components/icons/Instagram';
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import s from '../../styles/HttpStatusPages.styles.js';
import Logo from '../../components/icons/Logo.js';
import Error404 from '../../components/icons/Error404';
import Linkedin from '../../components/icons/Linkedin';

function Page404() {
  const { t } = useTranslation();

  const stylePageContent = {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '100px 0',
    position: 'relative',
  };

  return (
    <s.PageContainer>
      <s.container>
        <s.PageHeader>
          <a href="/">
            <Logo />
          </a>
          <div
            style={{
              display: 'flex',
            }}
          >
            <s.linkIcon href="https://www.linkedin.com/company/poscloud">
              <Linkedin />
            </s.linkIcon>
            <s.linkIcon href="https://www.instagram.com/poscloud.app/">
              <Instagram />
            </s.linkIcon>
          </div>
        </s.PageHeader>
        {/* <s.PageContent> */}
        <Row style={stylePageContent}>
          <Col xs={24} lg={12}>
            <s.textContainer>
              <s.textPrimary>
                {t('containers.Page404.somethingWrong')}
              </s.textPrimary>
              <s.textSecondary>
                {t('containers.Page404.pageNotFound')}
              </s.textSecondary>
              <s.textTertiary>
                {t('containers.Page404.pageNotFoundText')}
              </s.textTertiary>
            </s.textContainer>
            <s.containerButton>
              <s.Button
                href="/"
                style={{
                  marginRight: '33px',
                }}
              >
                {t('containers.Page404.pageInitial')}
              </s.Button>
              <s.Button
                href="https://dlocorp.com/"
                style={{
                  backgroundColor: '#fff',
                  color: Colors.text_primary,
                }}
              >
                {t('containers.Page404.contact')}
              </s.Button>
            </s.containerButton>
          </Col>
          <Col
            xs={0}
            lg={12}
            style={{
              position: 'absolute',
              top: -130,
              right: 0,
            }}
          >
            <Error404 />
          </Col>
        </Row>

        <s.PageFooter>
          <p>&copy; PosCloud App By DLO Europa</p>
        </s.PageFooter>
      </s.container>
    </s.PageContainer>
  );
}

export default Page404;
